import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircleIcon, UserIcon } from 'lucide-react';
export function AboutSection() {
  const stats = [{
    value: 'Perth',
    label: 'BASED'
  }, {
    value: '1:1',
    label: 'PERSONALISED STRATEGY'
  }, {
    value: 'Invest',
    label: 'BUILT TO SCALE'
  }, {
    value: 'Facts',
    label: 'STRATEGY OVER HYPE'
  }];
  const points = ['You work directly with me', 'Every strategy is built around your situation, not a template.', 'I focus on long-term positioning, not just getting a loan approved.', 'Clear, honest communication — no jargon, no pressure.'];
  return <section id="about" className="py-24 bg-white dark:bg-[#0f1629] border-t border-slate-100 dark:border-white/5 transition-colors duration-300 relative z-10" data-id="element-19" data-mp="1xnngabnweb70">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-20" data-mp="1no6ggavburiy">
        {/* Why Work With Me */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-24" data-id="element-21" data-mp="1jn307n9dath7">
          <div data-id="element-22" data-mp="1jp744579nshh">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-slate-50 dark:bg-primary-500/10 border border-slate-200 dark:border-primary-500/20 shadow-sm dark:shadow-none mb-6" data-id="element-23" data-mp="ssciz0irndgr">
              <span className="text-sm font-medium text-primary-600 dark:text-primary-400" data-id="element-24" data-mp="iu6goht1s5bd">
                Why Work With Me
              </span>
            </div>
            <h2 className="text-3xl md:text-5xl font-bold text-slate-900 dark:text-white mb-6 leading-tight" data-id="element-25" data-mp="nqwzhcw8lf0h">
              Strategy isn't just something I talk about —{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-accent-500 to-primary-500" data-id="element-26" data-mp="1ggc6lrks6nr4">
                it's something I apply.
              </span>
            </h2>
            <p className="text-lg text-slate-600 dark:text-slate-400 mb-6 leading-relaxed" data-id="element-27" data-mp="16ig2hjq9gt2i">
              I didn't start this business just to write loans. I started it
              because I saw a massive gap — too many brokers are order-takers,
              focused on getting a single deal done rather than looking at the
              big picture.
            </p>
            <p className="text-lg text-slate-600 dark:text-slate-400 mb-8 leading-relaxed" data-id="element-28" data-mp="1ss67gfoq0ngj">
              As an active property investor myself, I understand the nuances of
              building a portfolio. The structure of your first loan dictates
              your ability to get your third or fourth. I know how to navigate
              lender policies to maximise your position when it matters most.
            </p>

            <ul className="space-y-4 mb-8" data-id="element-29" data-mp="1a0dfmole18ae">
              {points.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-30" data-mp="152266ez08zsp" data-mpi={i}>
                  <CheckCircleIcon className="w-5 h-5 text-primary-500 flex-shrink-0 mt-0.5" data-id="element-31" data-mp="154em6ml7d034" />
                  <span className="text-slate-600 dark:text-slate-300 text-sm leading-relaxed" data-id="element-32" data-mp="1051zq2y8tv12">
                    {item}
                  </span>
                </li>)}
            </ul>

            
          </div>

          {/* Stats & Mission */}
          <div className="relative" data-id="element-33" data-mp="32ysj7v21sryc">
            <div className="absolute inset-0 bg-gradient-to-tr from-accent-500/8 to-primary-500/8 dark:from-accent-600/15 dark:to-primary-600/15 rounded-3xl blur-3xl -z-10" data-id="element-34" data-mp="32xr5fitndrcx"></div>
            <div className="bg-slate-50 dark:bg-[#1a2035] border border-slate-200 dark:border-white/10 rounded-3xl p-8 shadow-xl dark:shadow-none" data-id="element-35" data-mp="3brm2e3km8bhh">
              <div className="grid grid-cols-2 gap-4" data-id="element-36" data-mp="3gri41w5ubqtv">
                {stats.map((stat, index) => <div key={index} className="text-center p-4 md:p-6 rounded-2xl bg-white dark:bg-white/5 border border-slate-100 dark:border-white/5 flex flex-col items-center justify-center min-h-[120px] md:min-h-[140px] shadow-sm dark:shadow-none" data-id="element-37" data-mp="2k1hjyagf1yiw" data-mpi={index}>
                    <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-accent-500 to-primary-500 mb-2" data-id="element-38" data-mp="2xzfv76zfxeu6">
                      {stat.value}
                    </div>
                    <div className="text-[10px] sm:text-xs font-medium text-slate-500 dark:text-slate-400 uppercase tracking-wider leading-tight" data-id="element-39" data-mp="d7drdwukaiex">
                      {stat.label}
                    </div>
                  </div>)}
              </div>

              <div className="mt-6 p-6 rounded-2xl bg-gradient-to-r from-accent-600 to-primary-600 text-white shadow-lg" data-id="element-40" data-mp="1v6bs4chniya6">
                <h3 className="text-lg font-semibold mb-2" data-id="element-41" data-mp="1q77gzgb62qh7">Our Mission</h3>
                <p className="text-primary-50 text-sm leading-relaxed" data-id="element-42" data-mp="254hramc2pqbc">
                  To help Australians build real wealth through property — by
                  simplifying strategy, structuring loans properly, and giving
                  them the confidence to scale.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}